import * as React from "react";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { teamsWidgetStore } from "./TeamsWidgetStore";
import { Affix, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withModal } from "Components/General/Modal/ModalContext";
import { WithModal } from "Components/General/Modal/withModal";
import { TeamsWidgetForm } from "./TeamsWidgetForm";

interface TeamsWidgetProps extends WithTranslation, WithModal {}

export const TeamsWidget = withTranslation(I18N_NS.LOGIN)(
  withModal(
    observer(
      class extends React.Component<TeamsWidgetProps> {
        showFeedbackModal = () => {
          const { t, showModal } = this.props;
          showModal(TeamsWidgetForm, {
            modalProps: { footer: null, width: "100%", style: { maxWidth: 500 }, title: t("Request a feature") },
            componentProps: { email: teamsWidgetStore.usersEmail },
          });
        };
        render() {
          if (teamsWidgetStore.isInTeams) {
            return (
              <Affix offsetBottom={20} style={{ textAlign: "right" }}>
                <div className="pulse">
                  <Button shape="circle" type="primary" onClick={this.showFeedbackModal}>
                    <FontAwesomeIcon fixedWidth icon={["fas", "question-circle"]} />
                  </Button>
                </div>
              </Affix>
            );
          }
          return null;
        }
      }
    )
  )
);
